@if (dataAvailable) {
  <div class="mwg-wrapper flex-row">
    <div [ngClass]="showChartTable === true ? 'flex-70' : 'flex-100'">
      @for (chartType of mwgChartTypes; track chartType) {
        @if (chartData && chartData.data && chartData?.data[chartType] && chartData.data[chartType].dataSets) {
          <div class="chart-wrapper">
            <div class="type-label">{{ chartType | labelByChartType: chartData.tolerances }}</div>
            <colimo-mwg-chart-component
              [showChartFilters]="showChartFilters"
              [showChartTable]="showChartTable"
              [quadrant]="chartData.data[chartType].chQuadrant"
              [dataSet]="chartData.data[chartType].dataSets"
              [isVectorPage]="isVectorPage"
              [isMultiBatchCombined]="isMultiBatchCombined"
              [dataLabels]="lineChartLabels"
              [dataScale]="scale"
              [dataAngles]="lineChartLabels"
              [chartType]="chartType"
              [filters]="chartFilters"
              [selectedAngles]="selectedAngles"
              [activeComponents]="activeComponents"
            ></colimo-mwg-chart-component>
          </div>
        }
      }
    </div>
    @if (showChartTable && chartData?.data && chartData?.table) {
      <div class="flex-30" style="flex-grow: 0; flex-shrink: 0;">
        <colimo-chart-table
          [dataSet]="chartData.data"
          [angles]="chartData.angles"
          [table]="chartData.table"
          [tolerance]="chartData.tolerances"
          [batchType]="chartData.batchType"
          [filters]="chartFilters"
          [selectedAngles]="selectedAngles"
        ></colimo-chart-table>
      </div>
    }
  </div>
}

@if (!dataAvailable && !isLoading) {
  <div>
    <p class="missingData">{{ 'dashboard.missingData' | translate }}</p>
  </div>
}

@if (isLoading) {
  <colimo-loader [background]="'transparent'" [top]="'55%'"></colimo-loader>
}
